import { Flex } from '@chakra-ui/react'
import { QRCodeCanvas } from 'qrcode.react'
import { useEffect } from 'react'

import { FormModal } from '../../components/FormModal'
import { useAppToast } from '../../helpers'

interface IQrCodeModalProps {
  /** `null` fecha o modal. Ele fica montado para não pular a animação de saída. */
  url: string | null
  onClose: () => void
  title?: string
}

export default function QrCodeModal({ url, onClose, title }: IQrCodeModalProps) {
  const toast = useAppToast()

  useEffect(() => {
    return () => toast.closeAll()
  }, [])

  const handleDownload = () => {
    const canvas = document.getElementById('abra-qrcode-canvas') as HTMLCanvasElement | null
    if (!canvas) return
    const pngUrl = canvas.toDataURL('image/png')
    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = `${title || 'qrcode'}.png`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
    toast.success('Download iniciado')
  }

  return (
    <FormModal
      isOpen={url !== null}
      onClose={onClose}
      title="QR Code"
      onSubmit={handleDownload}
      size="compact"
      confirmLabel="Baixar PNG"
      cancelLabel="Fechar"
    >
      <Flex direction="column" alignItems="center" gap={4}>
        <QRCodeCanvas value={url ?? ''} size={220} id="abra-qrcode-canvas" includeMargin={true} />
        <div style={{ wordBreak: 'break-all', textAlign: 'center', fontSize: 14 }}>{url}</div>
      </Flex>
    </FormModal>
  )
}
